/* eslint-disable import/first */
import { showSingleMenu } from "../env";
import {
  projectRoutes,
  projectRoutesForSideBar,
  singleTestRoutes,
  singleTestRoutesForSideBar,
  authRoutes,
  settingsRoutes,
  settingsForSideBar,
  reportRoutes,
  reportForSideBar,
  supportPageRoutes,
  supportPageRoutesForSideBar, reportListForSideBar, reportListRoutes,
  reportListRoutes2,
  reportListForSideBar2,
  findRadonProForSideBar,
  radonMapRoutes2,
  radonMapForSideBar2,
  certifiedRoutes,
  reportRoutes2,
  certifiedRoutes2,
} from "./RouteComponents";
// import { landingRoutes } from "./PreliminaryRouteComponents";

// Routes using the Dashboard layout
export const dashboardLayoutRoutes = [
  projectRoutes,
  showSingleMenu ? singleTestRoutes : "",
  settingsRoutes,
  reportRoutes,
  reportListRoutes,
  reportRoutes2,
  reportListRoutes2,
  radonMapRoutes2,
  certifiedRoutes2,
  // supportPageRoutes,
];

// Routes using the Auth layout
export const authLayoutRoutes = [authRoutes];

// Routes using the Presentation layout
// export const presentationLayoutRoutes = [landingRoutes];

// Routes visible in the sidebar
export const sidebarRoutes = [
  // projectRoutesForSideBar,
  // showSingleMenu ? singleTestRoutesForSideBar : "",
  // settingsForSideBar,
  // reportForSideBar,
  reportListForSideBar,
  // supportPageRoutesForSideBar,
];

export const sidebarRoutes2 = [
  reportListForSideBar2,
  findRadonProForSideBar,
  radonMapForSideBar2,
];

